// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const HINT = "Tip";
export const STROLLERBASE_BANNER_TEXT = "Ko\u010d\u00e1rkopedie: najdi si ten prav\u00fd ko\u010d\u00e1rek";
